import { makeStyles } from "@material-ui/core";
import photo1 from "../../../../assets/sectionTwo1.png";
import photo2 from "../../../../assets/sectionTwo2.png";

const useStyles = makeStyles(({ breakpoints, spacing }) => ({
  background: {
    backgroundColor: "#EDF8F3",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "auto auto",
    alignItems: "center",
    marginBottom: "50vh",
  },
  card: {
    width: "70%",
    justifySelf: "center",
    display: "grid",
    gridTemplateRows: "auto auto auto",
    padding: spacing(4),
  },
  header: {
    position: "relative",
    marginBottom: spacing(3),
  },
  title: {
    width: "60%",
    fontWeight: "bold",
    fontSize: "36px",
    lineHeight: "100%",
    zIndex: 5,
    color: "	#404040",
    textShadow: " 4px 4px 2px rgba(150, 150, 150, 0.14)",
  },
  whenUnderline: {
    width: "50%",
    height: "2vh",
    backgroundColor: "#FEF3E7",
    position: "absolute",
    left: spacing(-1),
  },
  paragraph: {
    fontWeight: 300,
    fontSize: "24x",
    lineHeight: "24px",
  },
  moreInfo: {
    margin: `${spacing(2)}px 0`,
    justifySelf: "end",
    textTransform: "none!important",
    textDecoration: "none!important",
  },
  btnInfo: {
    textTransform: "none!important",
    textDecoration: "none!important",
    fontFamily: "Source Sans Pro !important",
    fontStyle: "normal !important",
    fontWeight: "bold !important",
    fontSize: "16px !important",
  },
  img: {
    width: "100%",
    height: "85vh",
    display: "grid",
    position: "relative",
    [breakpoints.up("xl")]: {
      height: "60vh",
    },
  },
  bkgImg1: {
    backgroundImage: `url(${photo1})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    justifySelf: "center",
    width: "75%",
    height: "100%",
    position: "absolute",
    top: spacing(-5),
  },
  bkgImg2: {
    backgroundImage: `url(${photo2})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    justifySelf: "center",
    width: "75%",
    height: "100%",
    position: "absolute",
    bottom: spacing(-5),
  },
  howUnderline: {
    width: "90%",
    height: "2vh",
    backgroundColor: "#FEF3E7",
    position: "absolute",
    left: spacing(-2),
  },
}));

export default useStyles;
